import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-10 md:pt-28 md:pb-16 px-4 bg-cream overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-52">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-53">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-sage text-primary font-semibold text-sm mb-2" data-id="element-54">
            <StarIcon className="w-4 h-4 mr-1 fill-accent text-accent" data-id="element-55" />
            <span data-id="element-56">El método #1 en nutrición canina</span>
          </div>

          <h1 className="mb-4 max-w-2xl font-serif font-[700] text-center" data-id="element-57">
            <span className="block text-3xl md:text-5xl lg:text-6xl text-charcoal leading-[1.15]" data-id="element-58">
              Transforma la alimentación de tu perro en 7 días
            </span>
            <span className="block text-[24px] leading-[1.2] mt-6 text-[#205010] font-semibold" data-id="element-59">
              Con alimentación natural, sin errores ni complicaciones
            </span>
          </h1>

          <p className="mb-6 max-w-xl text-[18px] font-[Inter,_sans-serif] leading-relaxed" data-id="element-60">
            <span className="text-[#374151] font-normal" data-id="element-61">Con </span>
            <span className="text-[#2D5016] font-bold" data-id="element-62">
              Nutrición Canina Fácil
            </span>
            <span className="text-[#374151] font-normal" data-id="element-63">
              {' '}
              vas a poder alimentar a tu perro de forma natural y segura,
              incluso si hoy no sabés por dónde empezar.
            </span>
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center gap-4" data-id="element-64">
            <CTAButton data-id="element-65" />
          </div>

          {/* Trust Badges */}
          <div className="pt-6 border-t border-gray-200 mt-6 w-full max-w-lg" data-id="element-66">
            <div className="flex items-center justify-center mb-3" data-id="element-67">
              <div className="flex mr-2" data-id="element-68">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-69" />)}
              </div>
              <span className="font-semibold text-charcoal" data-id="element-70">
                +2.000 dueños satisfechos
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-71">
              <span className="flex items-center" data-id="element-72">
                <ZapIcon className="w-4 h-4 mr-1 text-accent" data-id="element-73" /> Acceso
                inmediato
              </span>
              <span className="flex items-center" data-id="element-74">
                <ShieldCheckIcon className="w-4 h-4 mr-1 text-primary" data-id="element-75" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center" data-id="element-76">
                <LockIcon className="w-4 h-4 mr-1 text-gray-500" data-id="element-77" /> Pago seguro
              </span>
            </div>
          </div>
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center items-center perspective-1000" data-id="element-78">
          {/* Decorative background blob */}
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-79"></div>

          {/* Ebook Mockup */}
          <motion.div whileHover={{
          scale: 1.02
        }} className="relative z-10 w-full max-w-md flex items-center justify-center transform transition-transform duration-500" style={{
          filter: 'drop-shadow(0 25px 40px rgba(0,0,0,0.2)) drop-shadow(0 10px 15px rgba(0,0,0,0.12))'
        }} data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/juvrdCDTRt1qFbZEHp6o8m/Imagen_ebook_portada_primera.webp" alt="Nutrición Canina Fácil - Ebook + 7 Bonos de Regalo" className="w-full h-auto object-contain" loading="eager" decoding="sync" fetchPriority="high" width={800} height={800} data-id="element-81" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}